export const GLOBAL_SEARCH_TABS = Object.freeze({
  GLOBAL: "global",
  DETAIL_PERSON: "detailPerson",
  DETAIL_SITE: "detailSite",
  DETAIL_REFEREE: "detailReferee"
});

export const globalSearchTabs = Object.freeze([
  { value: GLOBAL_SEARCH_TABS.GLOBAL, label: "Global Search" },
  { value: GLOBAL_SEARCH_TABS.DETAIL_PERSON, label: "Person Search" },
  { value: GLOBAL_SEARCH_TABS.DETAIL_SITE, label: "Site Search" },
  { value: GLOBAL_SEARCH_TABS.DETAIL_REFEREE, label: "Referee Search" }
]);
